import { is80Height, is100Height, isHalfRack, is24Depth, is30Depth, is43Depth } from "./indyHelpers"
import { RackOptions } from "@/js/pages/product/rackbuilder/RackTypes"

// MARK: Cable Offsets
export function getFrontCableOffset(config: RackOptions) {
  if (is80Height(config)) {
    return { x: 0, y: -0.2, z: -0.2 }
  }
  
  if (is100Height(config)) {
    return { x: 0.1, y: -0.3, z: -0.4 }
  }
  
  return { x: 0.1, y: -0.35, z: -0.65 }
}

export function getBackCableOffset(config: RackOptions, left: boolean) {
  if (is80Height(config) && left) {
    return { x: 0.25, y: -0.1, z: 0 }
  }
  
  if (is80Height(config) && !left) {
    return { x: 0.2, y: -0.1, z: 0 }
  }
  
  if (is100Height(config)) {
    return { x: 0, y: 0, z: -0.1 }
  }
  
  return { x: 0, y: -0.35, z: 0 }
}

// MARK: Pulley Offsets
export function getFrontTopPulleyOffset(config: RackOptions, left: boolean) {
  if (is80Height(config)) {
    return left ? { x: 0.4, z: -6.1 } : { x: -0.4, z: -6.1 }
  }
  
  return left ? { x: 0.5, z: 0 } : { x: -0.4 }
}

export function getHRWeightStackPulleyOffset(config: RackOptions) {
  if (!isHalfRack(config)) {
    return {}
  }
  
  if (is24Depth(config) && !is80Height(config)) {
    return { z: 10 }
  }
  
  if (is80Height(config)) {
    return { x: 0, z: 10 }
  }
  
  if (is30Depth(config)) {
    return { x: -0.3, z: 0.5 }
  }
  
  return {}
}

// MARK: Rail Offsets
export function getTopRailOffset(config: RackOptions, left: boolean) {
  if (is80Height(config)) {
    return {}
  }
  
  return !left ? { x: 0, z: 0.5 } : {}
}

export function getBottomRailAnchor(config: RackOptions, left: boolean): string | undefined {
  if (left) {
    return 'main'
  }
  
  if (is80Height(config)) {
    return 'right'
  }
  
  return undefined
}

// MARK: Carriage Offsets
export function getIndyCarriageOffset(config: RackOptions) {
  if (is80Height(config)) {
    if (isHalfRack(config)) {
      return { x: -0.2, y: -13, z: -8.3 }
    }
    
    return { x: -0.2, y: -13, z: -6.8 }
  }
  
  if (isHalfRack(config) && is43Depth(config)) {
    return { x: -0.2, y: -10.5, z: -0.7 }
  }
  
  if (isHalfRack(config)) {
    return { x: -0.2, y: -10.5, z: -1.3 }
  }
  
  return { x: -0.2, y: -10.5, z: 0.1 }
}

// MARK: Weight Stack Offsets
export function getWeightStackOffset(config: RackOptions) {
  if (isHalfRack(config) && is30Depth(config)) {
    return { x: 0, y: 0, z: -3.6 }
  }
  
  if (isHalfRack(config) && is43Depth(config)) {
    return { x: 0, y: 0, z: -18 }
  }
  
  return {}
}

export function getHRShroudOffset(config: RackOptions) {
  if (!isHalfRack(config)) {
    return {}
  }
  
  if (is80Height(config)) {
    return { z: 0.3 }
  }
  
  if (is24Depth(config)) {
    return { z: 0 }
  }
  
  if (is30Depth(config)) {
    return { z: -4.8 }
  }
  
  if (is43Depth(config)) {
    return { z: -17.6 }
  }
  
  return {}
}